import { CheckInContent } from '../../../features/survey/check-in-content/check-in-content';

const Home = () => {
  return (
    <div className="form-container">
      <CheckInContent />
    </div>
  );
};

export { Home };
